import PropTypes from 'prop-types';
import classNames from 'classnames';
import { getColorThemeClass } from '../../helpers/colorThemes';
import './ColorThemePreview.scss';

const ColorThemePreview = ({ themeId }) => {
  return (
    <div className={classNames('ColorThemePreview', getColorThemeClass(themeId))}>
      <span className="music-tag verse">
        <span className="name">Verse 1</span>
      </span>
      <p className="ColorThemePreview__line">
        <span className="chord">G</span>
        {'          '}
        <span className="chord">D</span>
      </p>
      <p className="ColorThemePreview__line">In the quiet, in the storm</p>
    </div>
  );
};

ColorThemePreview.propTypes = {
  themeId: PropTypes.string,
};

export default ColorThemePreview;
